import "./NoMatch.css";
import { useState } from "react";
import useApp from "./AppContext";
import { Link } from "react-router-dom";
import { t } from './i18n'

function NoMatch() {
    const app = useApp();
    const [language] = useState(app.sessionToken?.Language);

    return (
        <div className="no-match">
            <h4>{t('noMatch.title', language)}</h4>
            <p>{t('noMatch.description', language)}</p>
            <img src="/images/404Page.png" alt="404Page" />
            <Link to="/">{t('noMatch.goBack', language)}</Link>
        </div>
    )
}

export default NoMatch;